import { render } from "./LoveItSlider.vue?vue&type=template&id=17c9c79d"
import script from "./LoveItSlider.vue?vue&type=script&lang=js"
export * from "./LoveItSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__